import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { paths } from '../../../../routing/path';

export interface MyReferralHubMenuItemProps {
    isReferralPartner?: boolean;
    withFlag?: boolean;
    className?: string;
    marginLeft?: number;
}

export const MyReferralHubMenuItem = (props: MyReferralHubMenuItemProps) => {
    const withFlag = props.withFlag ?? true;
    const label = props.isReferralPartner === false
        ? 'Become a Referral Partner'
        : 'My Referral Hub';

    return (
        <LeftMenuItem
            icon="pe-7s-share"
            label={label}
            to={paths.venues.share.myReferrals}
            flagCode={
                withFlag
                    ? NotificationFlagsCategories.ReferralHubCode
                    : undefined
            }
            className={props.className}
            marginLeft={props.marginLeft}
            trackingAction="My Referrals"
        />
    );
};
